import { logErrorOnce } from "./errorLogger";

export function initGlobalErrorHandler() {

  window.onerror = function (message, source, lineno, colno, error) {
    logErrorOnce({
      type: "window.onerror",
      message,
      source,
      lineno,
      colno,
      stack: error?.stack,
      url: window.location.href,
    });
  };

  window.onunhandledrejection = function (event) {
    logErrorOnce({
      type: "unhandledrejection",
      reason: event.reason?.toString(),
      stack: event.reason?.stack,
      url: window.location.href,
    });
  };
}
